const Mobile = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 17 22" fill="none">
      <path
        d="M16 6V16C16 20 15.0625 21 11.3125 21H5.6875C1.9375 21 1 20 1 16V6C1 2 1.9375 1 5.6875 1H11.3125C15.0625 1 16 2 16 6Z"
        stroke={color}
        strokeWidth="1.09615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.375 4.49951H6.625"
        stroke={color}
        strokeWidth="1.09615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 18.1C9.30254 18.1 9.95313 17.406 9.95313 16.55C9.95313 15.694 9.30254 15 8.5 15C7.69746 15 7.04688 15.694 7.04688 16.55C7.04688 17.406 7.69746 18.1 8.5 18.1Z"
        stroke={color}
        strokeWidth="1.09615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Mobile;
